import { createApi } from '@reduxjs/toolkit/query/react'

import baseQuery from './baseQuery'

export const caseworkAPI = createApi({
  reducerPath: 'caseworkApi',
  baseQuery: baseQuery(),
  endpoints: builder => ({
    resumePriorCasework: builder.mutation({
      query: ({ case_num }) => ({
        url: `/casework/${case_num}/resume_casework/`,
        method: 'POST',
      }),
    }),
    closePriorCasework: builder.mutation({
      query: ({ case_num }) => ({
        url: `/casework/${case_num}/close_prior_casework/`,
        method: 'POST',
      }),
    }),
    getTabsInfo: builder.query({
      query: () => ({
        url: '/casework/tabs/',
        method: 'GET',
      }),
    }),
  }),
})

export const {
  useResumePriorCaseworkMutation,
  useClosePriorCaseworkMutation,
  useGetTabsInfoQuery,
} = caseworkAPI
